import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import DialogActions from '@mui/material/DialogActions';

import { OPACITY_70 } from 'constants/opacity';
import { ITEM_DESCRIPTION_AND_PRICES } from 'styles/constants/appearanceSectionNames';
import { getHeaderAndNavigationTypography } from 'styles/helpers/getThemeStyles';
import { calculateRgbaWithAlpha } from 'helpers/colorFormatter';
import { CANCEL_GROUP_ORDER_CONFIRMATION } from 'bento-ordering/group_ordering/constants/groupOrder';
import { selectCartGroupOrderSlug } from 'bento-ordering/cart/selectors/index';
import PrimaryCta from 'components/Buttons/PrimaryCta';
import SecondaryCta from 'components/Buttons/SecondaryCta';
import { StyledTypographyColorSectionNavLinkMain } from 'components/Cart/StyledTypographyColorSectionNavLinkMain';
import { cancelGroupOrder } from 'bento-ordering/group_ordering/actions';
import { useRedirectToOOMenu } from 'bento-ordering/group_ordering/hooks';

const CancelGroupOrderConfirmation = ({ toggleIsOpen }) => {
  const dispatch = useDispatch();
  const groupOrderSlug = useSelector(selectCartGroupOrderSlug);

  const redirectToOO = useRedirectToOOMenu();

  const leaveGroupOrderButtonStyles = theme => ({
    color: calculateRgbaWithAlpha(
      theme.palette?.button?.background?.hover,
      OPACITY_70
    ),
    ...getHeaderAndNavigationTypography(theme)
  });

  const onConfirmHandler = async event => {
    event.preventDefault();

    const result = await dispatch(cancelGroupOrder(groupOrderSlug));

    if (result?.error !== true) {
      redirectToOO();
    } else {
      toggleIsOpen();
    }
  };

  return (
    <Box
      height="100%"
      display="flex"
      flexDirection="column"
      justifyContent="center"
    >
      <>
        <StyledTypographyColorSectionNavLinkMain
          textAlign="center"
          component="h4"
          variant={ITEM_DESCRIPTION_AND_PRICES}
        >
          {CANCEL_GROUP_ORDER_CONFIRMATION.title}
        </StyledTypographyColorSectionNavLinkMain>
        <DialogActions>
          <Box mt={2}>
            <PrimaryCta
              label={CANCEL_GROUP_ORDER_CONFIRMATION.yes}
              handleClick={onConfirmHandler}
              fullWidth
            />
          </Box>
          <Box mt={2}>
            <SecondaryCta
              label={CANCEL_GROUP_ORDER_CONFIRMATION.no}
              handleClick={toggleIsOpen}
              fullWidth
              sx={leaveGroupOrderButtonStyles}
            />
          </Box>
        </DialogActions>
      </>
    </Box>
  );
};

CancelGroupOrderConfirmation.propTypes = {
  toggleIsOpen: PropTypes.func.isRequired
};

export default CancelGroupOrderConfirmation;
